import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileBookingBar from "./MobileBookingBar";
import { ui } from "@/content";

const useScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({ block: "start" }), 60);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
};

export default function Layout() {
  useScrollManager();
  return (
    <div className="flex min-h-screen flex-col bg-cream text-ink">
      <a href="#main" className="skip-link" data-testid="skip-to-content">{ui.skipToContent}</a>
      <Header />
      <main id="main" tabIndex={-1} className="flex-1 pb-20 outline-none md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileBookingBar />
    </div>
  );
}
